import { gql } from '@apollo/client'
import { useActionMutation, type UseMutationProps } from '@ztechapps/common.hook'
import type { Task, TaskStatusActionConfig } from '@ztechapps/common.contract'
import { taskStatusActionConfigFragment } from './graphql'

export const updateTaskStatusActionsMutation = gql`
  mutation updateTaskStatusActions($input: UpdateTaskStatusActionsArgs!) {
    updateTaskStatusActions(input: $input) {
      _id
      statusActions {
        ...taskStatusActionConfigFragment
      }
    }
  }
  ${taskStatusActionConfigFragment}
`

export type UpdateTaskStatusActionsInput = {
  filter: { _id: string }
  statusActions: Partial<TaskStatusActionConfig>[]
}

export type UseUpdateTaskStatusActionsResult = ReturnType<typeof useUpdateTaskStatusActions>

/**
 * Hook for updating task status actions configuration.
 * Uses the updateTaskStatusActions mutation to replace the task's statusActions array.
 */
export const useUpdateTaskStatusActions = ({ query, ...props } = {} as UseMutationProps) => {
  query = query ?? updateTaskStatusActionsMutation

  return useActionMutation<Task, UpdateTaskStatusActionsInput>({
    query,
    ...props,
  })
}
